// extracted by mini-css-extract-plugin
module.exports = {"input":"FieldCurrencyInput_input__1B74U","inputSuccess":"FieldCurrencyInput_inputSuccess__3tPC8","inputError":"FieldCurrencyInput_inputError__24SJS"};